import type { ReactNode } from "react"

import AppMobileLayout from "@/layouts/app/app-mobile-layout"
import type { BreadcrumbItem } from "@/types"

interface AppLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
  title?: string
  showMobileNav?: boolean
  showMobileHeader?: boolean
  showDefaultHeaderRightActions?: boolean
  // MobileHeader props
  showBackButton?: boolean
  showShareButton?: boolean
  showFavoriteButton?: boolean
  showEditButton?: boolean
  showDeleteButton?: boolean
  onBack?: () => void
  onShare?: () => void
  onFavorite?: (isFavorite: boolean) => void
  onEdit?: () => void
  onDelete?: () => void
  onCreateChat?: () => void
  isFavorite?: boolean
  favoritesCount?: number
  headerChildren?: ReactNode
  headerRightActions?: ReactNode
}

export default function AppLayout({
  children,
  breadcrumbs,
  title,
  showMobileNav = true,
  // MobileHeader props
  showBackButton = false,
  showShareButton = false,
  showFavoriteButton = false,
  showEditButton = false,
  showDeleteButton = false,
  onBack,
  onShare,
  onFavorite,
  onEdit,
  onDelete,
  onCreateChat,
  isFavorite = false,
  favoritesCount,
  headerChildren,
  ...props
}: AppLayoutProps) {
  return (
    <AppMobileLayout
      breadcrumbs={breadcrumbs}
      title={title}
      showMobileNav={showMobileNav}
      // MobileHeader props
      showBackButton={showBackButton}
      showShareButton={showShareButton}
      showFavoriteButton={showFavoriteButton}
      showEditButton={showEditButton}
      showDeleteButton={showDeleteButton}
      onBack={onBack}
      onShare={onShare}
      onFavorite={onFavorite}
      onEdit={onEdit}
      onDelete={onDelete}
      onCreateChat={onCreateChat}
      isFavorite={isFavorite}
      favoritesCount={favoritesCount}
      headerChildren={headerChildren}
      {...props}
    >
      {children}
    </AppMobileLayout>
  )
}
